import { injectable } from '@servicetitan/react-ioc';
import { CancelToken } from 'axios';

import { HttpClient } from './http-client';

export interface InvoiceItemRequest {
    id: number | string;
    name?: string;
    description?: string;
    cost?: number;
    price?: number;
}

export interface InvoiceItemResponse {
    data?: any;
}

@injectable()
export class InvoicesApi {
    constructor(private readonly httpClient: HttpClient) {}

    addInvoiceItem = (
        invoiceId: number,
        item: InvoiceItemRequest,
        cancellationToken?: CancelToken
    ) => {
        return this.httpClient.post<InvoiceItemResponse, InvoiceItemRequest>(
            `/api/v1/invoices/${invoiceId}/items`,
            item,
            {
                cancelToken: cancellationToken,
            }
        );
    };
}
